import * as Actions from '../../actions';

const initialState = { data: null };

const inspectReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.SET_INSPECT_ROUTE_SESSION_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default inspectReducer;
